import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { COPYRIGHT } from "@/lib/legalTexts";

export const LegalDialog = ({ open, onOpenChange, doc }) => {
  if (!doc) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="legal-dialog" className="bg-[var(--surface)] border-[var(--border)] text-[var(--text-primary)] max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-head text-xl text-[var(--pos)]">{doc.title}</DialogTitle>
          <DialogDescription className="text-xs text-[var(--text-faint)]">CryptoSense yasal metni</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-4">
          <p className="text-sm text-[var(--text-muted)] whitespace-pre-line leading-relaxed">{doc.body}</p>
          <p className="mt-6 pt-4 border-t border-[var(--border)] text-[11px] text-[var(--text-faint)] font-mono">{COPYRIGHT}</p>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
